<div class="h-full w-full">
    <!-- <app-modal-header [closeButton]="true"></app-modal-header> -->
    <div class="flex justify-center items-center h-full">
        <div class="rounded-2xl bg-[#fff] h-3/4 w-full pt-2" style="background-image: url('/assets/images/emblembg.png'); background-repeat: no-repeat; background-position: center; background-size: 55%">
            <div class="">
                <form [formGroup]="feedBackForm" autocomplete="off" novalidate>
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-6">
                                <mat-form-field style="width: 100% !important;" appearance="outline" class="material-form">
                                    <input placeholder="fullname" formControlName="fullname" matInput />
                                    <mat-icon matPrefix svgIcon="user" class="mx-2"></mat-icon>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="outline" style="width: 100% !important;" class="material-form">
                                    <input placeholder="Phonenumber" formControlName="Phonenumber" matInput />
                                    <mat-icon matPrefix svgIcon="phone" class="mx-2"></mat-icon>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="outline" style="width: 100% !important;" class="material-form">
                                    <input placeholder="Email" formControlName="Email" matInput />
                                    <mat-icon matPrefix svgIcon="email" class="mx-2"></mat-icon>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field appearance="outline" style="width: 100% !important;">
                                    <mat-select placeholder="Feedback category">
                                        <mat-option *ngFor="let category of feedbackCategories" [value]="category.value" class="option">
                                        <span class="flex justify-center">
                                            {{category.name}}
                                        </span>
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                            </div>
                            <div class="col-12">
                                <mat-form-field appearance="outline" style="width: 100% !important;">
                                    <textarea matInput rows="5" cols="40"></textarea>
                                </mat-form-field>
                            </div>
                        </div>
                    </div>
                    <div class="container">
                        <div class="row">

                            <div class="col-3">

                            </div>
                        </div>
                    </div>

                    <div class="flex justify-between items-center my-3">
                        <!-- BEGIN: Cancel button -->
                        <div>
                            <button type="submit" class="bg-tertiary-500 text-[#fff] rounded-full px-3 py-2 w-44" (click)="closeModal($event)">
                                cancel
                            </button>
                        </div>
                        <!-- END: Cancel button -->
                        <!-- BEGIN: Submit button -->
                        <div>
                            <button type="submit" class="bg-[#28409A] text-[#fff] rounded-full px-3 py-2 w-44">
                                Submit
                            </button>
                        </div>
                        <!-- BEGIN: Submit button -->
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>

